import React, { useState, useEffect } from "react";
import { createSearchParams, useNavigate } from "react-router-dom";

import { Button } from "primereact/button";
import { Steps } from "primereact/steps";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";

import { useAuth } from "context/AuthContext";
import { useLoading } from "context/LoadingContext";
import { useNotification } from "context/NotificationContext";

import Api from "utils/Api";
import MaskUtil from "utils/MaskUtil";
import useQuery from "utils/useQuery";
import { validarCPF } from "utils/ValidacaoUtils";

import DadosColaborrador from "./modules/DadosColaborrador";
import Documentos from "./modules/Documentos";
import ExameMedico from "./modules/ExameMedico";
import InformacoesDependentes from "./modules/InformacoesDependentes";
import InformacoesPessoais from "./modules/InformacoesPessoais";

const FormularioFinalizacao = () => {
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const auth = useAuth();
  const notify = useNotification();
  const query = useQuery();
  const Requicicao = new Api();

  const steps = [
    { label: "Informações Pessoais" },
    { label: "Dados do Colaborador" },
    { label: "Exame Médico" },
    { label: "Informações dos Dependentes" },
    { label: "Documentos" }
  ];

  const [funcionarioId, setfuncionarioId] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [Escolaridades, setEscolaridades] = useState([]);
  const [tiposParentesco, setTiposParentesco] = useState([]); // NOVA ADIÇÃO
  const [statusAptidao, setStatusAptidao] = useState("");

  const [dados, setDados] = useState({
    nome: "",
    cpf: "",
    rg: "",
    // Campos de endereço segregados
    cep: "",
    logradouro: "",
    numero: "",
    complemento: "",
    bairro: "",
    cidade: "",
    estado: "",
    email: "",
    telefone: "",
    banco: "",
    agencia: "",
    contaCorrente: ""
  });

  const [arquivos, setArquivos] = useState({
    foto: null,
    pisEsocial: null,
    rg: null,
    cpf: null,
    carteiraTrabalho: null,
    dadosBancarios: null,
    tituloEleitor: null,
    reservista: null,
    cnh: null,
    escolaridade: null,
    dependentes: null,
    pensaoAlimenticia: null
  });

  const [dependente, setDependente] = useState({
    nome: "",
    dataNascimento: null,
    parentesco: "",
    cpf: ""
  });

  const [Exame, setExame] = useState(null);
  const [personalErrors, setPersonalErrors] = useState({});
  const [exameErrors, setExameErrors] = useState({});
  const [dependenteErrors, setDependenteErrors] = useState({});

  const camposObrigatoriosPessoais = [
    "pis",
    "carteiraTrabalho",
    "tituloEleitor",
    "escolaridadeId",
    "tamanhoUniforme"
  ];

  const camposObrigatoriosColaborador = [
    "nome",
    "cpf",
    "rg",
    "cep",
    "logradouro",
    "numero",
    "bairro",
    "cidade",
    "estado",
    "email",
    "telefone",
    "banco",
    "agencia",
    "contaCorrente"
  ];
  const [colaboradorErrors, setColaboradorErrors] = useState({});

  const ValidarCamposColaborador = () => {
    const errors = {};
    camposObrigatoriosColaborador.forEach((campo) => {
      if (campo === "cep") {
        if (!dados.cep || dados.cep.replace(/\D/g, '').length < 8) {
          errors[campo] = true;
        }
      } else if (!dados[campo] || dados[campo].trim() === "") {
        errors[campo] = true;
      }
    });
    setColaboradorErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const HandleChange = (event) => {
    const { name, value } = event.target;
    setDados((prevState) => ({ ...prevState, [name]: value }));
    
    // Limpa o erro do campo quando o usuário começa a digitar
    if (exameErrors[name]) {
      setExameErrors(prev => ({ ...prev, [name]: false }));
    }
  };

  const HandleDependenteChange = (field, value) => {
    setDependente(prev => ({ ...prev, [field]: value }));
    
    // Limpa o erro do campo quando o usuário interage
    if (dependenteErrors[field]) {
      setDependenteErrors(prev => ({ ...prev, [field]: false }));
    }
  };

  const HandleFileChange = (e, category) => {
    const file = e.files && e.files[0];
    setArquivos((prevState) => ({ ...prevState, [category]: file }));
  };

  const HandleExameChange = (e) => {
    console.log('📁 HandleExameChange chamada');
    console.log('📋 Evento recebido:', e);
    console.log('📁 Files:', e.files);
    
    const file = e.files && e.files[0];
    console.log('📄 Arquivo selecionado:', file);
    
    setExame(file);
    console.log('💾 Estado Exame atualizado:', file);
    
    // Limpa o erro do exame quando o usuário faz upload
    if (exameErrors.exame) {
      console.log('🧹 Limpando erro do exame');
      setExameErrors(prev => ({ ...prev, exame: false }));
    }
  };

  const ValidarCamposObrigatorios = () => {
    const camposObrigatorios = [
      "nome",
      "cpf",
      "rg",
      "cep",
      "logradouro",
      "numero",
      "bairro",
      "cidade",
      "estado",
      "email",
      "telefone",
      "banco",
      "agencia",
      "contaCorrente"
    ];
    for (const campo of camposObrigatorios) {
      if (campo === "cep") {
        if (!dados.cep || dados.cep.replace(/\D/g, '').length < 8) {
          notify({
            type: "error",
            message: `Por favor, preencha o campo: ${campo}`
          });
          return false;
        }
      } else if (!dados[campo] || dados[campo].trim() === "") {
        notify({
          type: "error",
          message: `Por favor, preencha o campo: ${campo}`
        });
        return false;
      }
    }
    return true;
  };

  const ValidarArquivosObrigatorios = () => {
    const obrigatorios = [
      "foto",
      "pisEsocial",
      "rg",
      "cpf",
      "carteiraTrabalho",
      "dadosBancarios"
    ];

    const labels = {
      foto: "Foto",
      pisEsocial: "PIS | eSocial",
      rg: "RG",
      cpf: "CPF",
      carteiraTrabalho: "Carteira de Trabalho",
      dadosBancarios: "Dados Bancários"
    };

    const faltantes = obrigatorios.filter((categoria) => !arquivos[categoria]);

    if (faltantes.length > 0) {
      const listaFormatada = faltantes
        .map((key) => `• ${labels[key] || key}`)
        .join("<br/><br/>");

      notify({
        type: "error",
        message: `Por favor, envie os seguintes arquivos obrigatórios:<br/>${listaFormatada}`
      });

      return false;
    }

    return true;
  };

  const ValidarCamposPessoais = () => {
    const errors = {};
    camposObrigatoriosPessoais.forEach((campo) => {
      if (
        !dados[campo] ||
        (campo === "escolaridadeId" && dados[campo] === "00000000-0000-0000-0000-000000000000")
      ) {
        errors[campo] = true;
      }
    });
    setPersonalErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const ValidarExameMedico = () => {
    console.log('🔍 ValidarExameMedico chamada');
    console.log('📝 Dados do exame:', {
      nomeMedico: dados.nomeMedico,
      crm: dados.crm,
      dataAdmissaoExam: dados.dataAdmissaoExam,
      Exame
    });
    
    const errors = {};
    let hasErrors = false;
    
    // Validação do nome do médico
    if (!dados.nomeMedico || dados.nomeMedico.trim() === "") {
      errors.nomeMedico = true;
      hasErrors = true;
      console.log('❌ ERRO: Nome do médico vazio');
    } else {
      console.log('✅ Nome do médico preenchido');
    }
    
    // Validação do CRM
    if (!dados.crm || dados.crm.trim() === "") {
      errors.crm = true;
      hasErrors = true;
      console.log('❌ ERRO: CRM vazio');
    } else {
      console.log('✅ CRM preenchido');
    }
    
    // Validação da data do exame
    if (!dados.dataAdmissaoExam || dados.dataAdmissaoExam.trim() === "") {
      errors.dataAdmissaoExam = true;
      hasErrors = true;
      console.log('❌ ERRO: Data do exame vazia');
    } else {
      console.log('✅ Data do exame preenchida');
    }
    
    // Validação do upload do exame
    if (!Exame) {
      errors.exame = true;
      hasErrors = true;
      console.log('❌ ERRO: Arquivo do exame não enviado');
    } else {
      console.log('✅ Arquivo do exame enviado:', Exame.name);
    }
    
    console.log('📋 Erros encontrados:', errors);
    console.log('🔍 Tem erros?', hasErrors);
    
    setExameErrors(errors);
    
    if (hasErrors) {
      console.log('❌ Validação falhou - exibindo toast');
      notify({
        type: "error",
        message: "Por favor, preencha todos os campos obrigatórios do exame médico."
      });
      return false;
    }
    
    console.log('✅ Validação do exame médico aprovada');
    return true;
  };

  const ValidarDependentes = () => {
    // Se não possui dependentes, não precisa validar
    if (!dados.possuiDependentes) {
      return true;
    }
    
    // Se possui dependentes mas já tem pelo menos um na lista, não precisa validar os campos
    if (dados.dependentes && dados.dependentes.length > 0) {
      return true;
    }
    
    const errors = {};
    let hasErrors = false;
    
    // Validação do nome do dependente
    if (!dependente.nome || dependente.nome === null || dependente.nome.trim() === "") {
      errors.nome = true;
      hasErrors = true;
    }
    
    // Validação da data de nascimento
    if (!dependente.dataNascimento || dependente.dataNascimento === null || dependente.dataNascimento === "") {
      errors.dataNascimento = true;
      hasErrors = true;
    }
    
    // Validação do parentesco
    if (!dependente.parentesco || dependente.parentesco === null || dependente.parentesco === "") {
      errors.parentesco = true;
      hasErrors = true;
    }
    
    // Validação do CPF
    if (!dependente.cpf || dependente.cpf === null || dependente.cpf === "") {
      errors.cpf = true;
      hasErrors = true;
    }
    
    setDependenteErrors(errors);
    
    if (hasErrors) {
      notify({
        type: "error",
        message: "Por favor, preencha todos os campos obrigatórios do dependente."
      });
      return false;
    }
    
    return true;
  };

  const HandleNext = () => {
    if (activeIndex === 0) {
      if (!ValidarCamposPessoais()) {
        notify({
          type: "error",
          message: "Preencha todos os campos obrigatórios."
        });
        return;
      }
    }
    if (activeIndex === 1) {
      if (!ValidarCamposColaborador()) {
        notify({
          type: "error",
          message: "Preencha todos os campos obrigatórios de Dados do Colaborador."
        });
        return;
      }
    }
    if (activeIndex === 2) {
      console.log('🔍 Step 2 (Exame Médico) - Validando...');
      if (!ValidarExameMedico()) {
        console.log('❌ Validação do exame médico falhou - bloqueando avanço');
        return;
      }
      console.log('✅ Validação do exame médico aprovada - permitindo avanço');
    }
    if (activeIndex === 3) {
      if (!ValidarDependentes()) {
        return;
      }
    }
    setActiveIndex((prevIndex) => prevIndex + 1);
  };

  const HandleBack = () => {
    setActiveIndex((prevIndex) => prevIndex - 1);
  };

  const HandleDropdownChange = (e, field) => {
    setDados((prevState) => ({ ...prevState, [field]: e.value }));
  };

  // MELHORIA 1: Nova confirmação com ConfirmPopup
  const ConfirmacaoVoltar = (event) => {
    confirmPopup({
      target: event.currentTarget,
      message: "Tem certeza que deseja voltar? Todos os dados não salvos serão perdidos.",
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "reject",
      acceptClassName: "p-button-warning",
      acceptLabel: "Sim, voltar",
      rejectLabel: "Cancelar",
      accept: () => navigate(-1),
      reject: () => {}
    });
  };

  const HandleSubmit = async (event) => {
    event.preventDefault();

    if (!ValidarCamposObrigatorios()) return;
    if (!ValidarArquivosObrigatorios()) return;

    try {
      setLoading(true);

      const formData = new FormData();

      const dataToForm = dados;
      dataToForm.statusAptidao = statusAptidao === "Apto";
      // Os campos de endereço já estão segregados no objeto dados
      dataToForm.dataAdmissaoExam = dados.dataAdmissaoExam ? (() => {
        try {
          const [day, month, year] = dados.dataAdmissaoExam.split('/');
          const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
          return date.toISOString();
        } catch (error) {
          console.error("Erro ao formatar data do exame para envio:", error);
          return null;
        }
      })() : null;

      delete dataToForm.pcdId;
      delete dataToForm.funcao;
      delete dataToForm.funcaoId;
      delete dataToForm.departamentoId;
      delete dataToForm.departamento;
      delete dataToForm.statusCadastro;
      delete dataToForm.valeAlimentacao;
      delete dataToForm.valeRefeicao;
      delete dataToForm.valeTransporte;
      delete dataToForm.planoSaude;
      delete dataToForm.planoOdontologico;
      delete dataToForm.seguroVida;
      delete dataToForm.auxilioCreche;
      delete dataToForm.valeAcademia;
      delete dataToForm.auxilioHomeOffice;
      delete dataToForm.tipoComissao;
      delete dataToForm.percentualComissao;
      delete dataToForm.comissaoFixa;

      for (const key in dataToForm) {
        if (Object.prototype.hasOwnProperty.call(dados, key)) {
          formData.append(key, dados[key]);
        }
      }

      for (const key in arquivos) {
        if (
          Object.prototype.hasOwnProperty.call(arquivos, key) &&
          arquivos[key]
        ) {
          const arquivo = arquivos[key];
          const nomeModificado = `${key}_${arquivo.name}`;
          const arquivoModificado = new File([arquivo], nomeModificado, {
            type: arquivo.type
          });

          formData.append("arquivosContratacao", arquivoModificado);
        }
      }

      const data = await Requicicao.Put({
        endpoint: `/Funcionarios/${funcionarioId}/EditarComDocumentos`,
        data: formData,
        config: auth.GetHeaders("multipart/form-data")
      });

      if (data?.codigoEstadoHttp === 200) {
        // MELHORIA 2: Melhor tratamento dos dependentes
        if (dados?.dependentes?.length > 0) {
          const dependentesParaEnviar = dados.dependentes.map(dep => ({
            nome: dep.nome,
            dataNascimento: dep.dataNascimento || dep.nascimento,
            parentesco: typeof dep.parentesco === 'number' ? dep.parentesco : parseInt(dep.parentesco, 10),
            cpf: dep.cpf
          }));

          await Requicicao.Put({
            endpoint: "/Funcionarios/Dependente",
            data: {
              id: funcionarioId,
              dependentes: dependentesParaEnviar
            }
          });
        }

        if (Exame) {
          const formDataExame = new FormData();

          const Dados = {
            funcionarioId,
            nomeArquivo: "ExameMedico",
            descricao: "documentos de exame de admissão Medico",
            tipoArquivo: 4
          };

          const dataToFormExame = Dados;

          for (const key in dataToFormExame) {
            if (Object.prototype.hasOwnProperty.call(Dados, key)) {
              formDataExame.append(key, Dados[key]);
            }
          }

          if (Exame) {
            formDataExame.append("arquivoFuncionario", Exame);
          } else {
            notify({
              type: "aviso",
              message: "Por favor, selecione um arquivo para fazer upload."
            });
          }

          await Requicicao.Put({
            endpoint: `/Funcionarios/AdicionarArquivosFuncionario`,
            data: formDataExame,
            config: auth.GetHeaders("multipart/form-data")
          });
        }

        notify({
          type: "success",
          message: "Informações atualizadas com sucesso."
        });

        setTimeout(() => {
          navigate({
            pathname: "/boasVindas/dados",
            search: createSearchParams({
              id: funcionarioId
            }).toString()
          });
          setLoading(false);
        }, 1500);
      }
    } catch (error) {
      console.error("Erro ao salvar o funcionário:", error);
      notify({
        type: "error",
        message: "Erro ao salvar as informações. Tente novamente mais tarde."
      });
      setLoading(false);
    }
  };

  const SetDadosEndereco = async (cep) => {
    try {
      setLoading(true);
      const data = await Requicicao.Get({
        url: `https://viacep.com.br/ws/${cep}/json/`
      });
      if (data.uf) {
        setDados(prev => ({
          ...prev,
          logradouro: data.logradouro || "",
          bairro: data.bairro || "",
          cidade: data.localidade || "",
          estado: data.uf || ""
        }));
      } else {
        notify({
          type: "error",
          message: "CEP não encontrado"
        });
      }
    } catch (error) {
      notify({
        type: "error",
        message: "Erro ao buscar CEP"
      });
    } finally {
      setLoading(false);
    }
  };

  // MELHORIA 2: Melhor validação e tratamento dos dependentes
  const HandleAddDependente = () => {
    // Validação visual dos campos obrigatórios
    const errors = {};
    let hasErrors = false;
    
    if (!dependente.nome || dependente.nome === null || dependente.nome.trim() === "") {
      errors.nome = true;
      hasErrors = true;
    }

    if (!dependente.dataNascimento || dependente.dataNascimento === null || dependente.dataNascimento === "") {
      errors.dataNascimento = true;
      hasErrors = true;
    }

    if (!dependente.parentesco || dependente.parentesco === null || dependente.parentesco === "") {
      errors.parentesco = true;
      hasErrors = true;
    }
    
    if (!dependente.cpf || dependente.cpf === null || dependente.cpf === "") {
      errors.cpf = true;
      hasErrors = true;
    } else if (!validarCPF(dependente.cpf)) {
      errors.cpf = true;
      hasErrors = true;
    }
    
    setDependenteErrors(errors);
    
    if (hasErrors) {
      notify({
        type: "error",
        message: "Por favor, preencha todos os campos obrigatórios do dependente."
      });
      return;
    }

    const dataNascimentoFormatada = dependente.dataNascimento ? (() => {
      try {
        if (dependente.dataNascimento instanceof Date) {
          return dependente.dataNascimento.toISOString();
        }
        if (typeof dependente.dataNascimento === 'string') {
          const [day, month, year] = dependente.dataNascimento.split('/');
          const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
          return date.toISOString();
        }
        return dependente.dataNascimento;
      } catch (error) {
        console.error("Erro ao formatar data de nascimento do dependente:", error);
        return dependente.dataNascimento;
      }
    })() : null;

    setDados((prev) => ({
      ...prev,
      dependentes: [
        ...(prev.dependentes ?? []),
        {
          cpf: dependente.cpf,
          nome: dependente.nome.trim(),
          dataNascimento: dataNascimentoFormatada,
          parentesco: parseInt(dependente.parentesco, 10)
        }
      ]
    }));

    setDependente({ nome: "", dataNascimento: null, parentesco: "", cpf: "" });
  };

  const RemoverDependente = (cpf) => {
    setDados((prev) => ({
      ...prev,
      dependentes: prev.dependentes.filter((x) => x.cpf !== cpf)
    }));
  };

  useEffect(() => {
    const CarregarEscolaridades = async () => {
      try {
        const response = await Requicicao.Get({
          endpoint: "/Funcionarios/Escolaridades",
          config: auth.GetHeaders()
        });
        if (response.codigoEstadoHttp === 200) {
          const formattedEscolaridades = response.objetoResposta.map(
            (escolaridade) => ({
              label: escolaridade.descricao,
              value: escolaridade.id
            })
          );
          setEscolaridades(formattedEscolaridades);
        }
      } catch (error) {
        console.error("Erro ao carregar escolaridades:", error);
      }
    };

    // MELHORIA 2: Nova função para carregar tipos de parentesco
    const CarregarTiposParentesco = async () => {
      try {
        const response = await Requicicao.Get({
          endpoint: "/Dependentes/TiposParentesco",
          config: auth.GetHeaders()
        });
        if (response.codigoEstadoHttp === 200) {
          const formattedTiposParentesco = response.objetoResposta.map((tipo) => ({
            label: tipo.descricao,
            value: tipo.id
          }));
          setTiposParentesco(formattedTiposParentesco);
        }
      } catch (error) {
        console.error("Erro ao carregar tipos de parentesco:", error);
      }
    };

    const CarregarDadosFuncionario = async () => {
      try {
        setLoading(true);
        const response = await Requicicao.Get({
          endpoint: `/Funcionarios/${funcionarioId}`,
          config: auth.GetHeaders()
        });
        if (response.codigoEstadoHttp === 200) {
          // MELHORIA 2: Normalização dos dependentes vindos do backend
          const dependentesNormalizados = response.objetoResposta.dependentes?.map(dep => ({
            ...dep,
            dataNascimento: dep.nascimento,
            parentesco: dep.parentescoId,
            parentescoDescricao: dep.parentescoDescricao
          })) || [];

          setDados((prevState) => ({
            ...prevState,
            ...response.objetoResposta,
            dependentes: dependentesNormalizados,
            cpf: MaskUtil.applyCpfMask(response.objetoResposta.cpf),
            rg: MaskUtil.applyRgMask(response.objetoResposta.rg),
            telefone: MaskUtil.applyTelefoneMask(
              response.objetoResposta.telefone
            )
          }));
        }
      } catch (error) {
        console.error("Erro ao carregar os dados do funcionário:", error);
        notify({
          type: "error",
          message:
            "Erro ao carregar os dados do funcionário. Tente novamente mais tarde."
        });
      } finally {
        setLoading(false);
      }
    };

    if (funcionarioId != null) {
      CarregarDadosFuncionario();
      CarregarEscolaridades();
      CarregarTiposParentesco(); // NOVA CHAMADA
    }
  }, [funcionarioId]);

  useEffect(() => {
    setfuncionarioId(query.get("id"));
  }, [query]);

  return (
    <div className="box-bem-vindo">
      <ConfirmPopup />
      <div className="container">
        <form className="card p-4 mt-3 mb-3">
          <Steps model={steps} activeIndex={activeIndex} />
          <div>
            {activeIndex === 0 && (
              <InformacoesPessoais
                dados={dados}
                HandleChange={HandleChange}
                HandleDropdownChange={HandleDropdownChange}
                Escolaridades={Escolaridades}
                obrigatorios={camposObrigatoriosPessoais}
                errors={personalErrors}
              />
            )}

            {activeIndex === 1 && (
                          <DadosColaborrador
              dados={dados}
              setDados={setDados}
              HandleChange={HandleChange}
              errors={colaboradorErrors}
              obrigatorios={camposObrigatoriosColaborador}
            />
            )}

            {activeIndex === 2 && (
              <ExameMedico
                dados={dados}
                HandleChange={HandleChange}
                statusAptidao={statusAptidao}
                setStatusAptidao={setStatusAptidao}
                HandleExameChange={HandleExameChange}
                errors={exameErrors}
                exameFile={Exame}
              />
            )}

            {activeIndex === 3 && (
              <InformacoesDependentes
                dados={dados}
                HandleChange={HandleChange}
                dependente={dependente}
                setDependente={setDependente}
                HandleAddDependente={HandleAddDependente}
                RemoverDependente={RemoverDependente}
                tiposParentesco={tiposParentesco}
                errors={dependenteErrors}
                HandleDependenteChange={HandleDependenteChange}
              />
            )}

            {activeIndex === 4 && (
              <Documentos HandleFileChange={HandleFileChange} arquivos={arquivos} />
            )}
          </div>

          <div className="d-flex justify-content-end gap-3">
            <Button
              type="button"
              className="btn btn-secondary"
              onClick={ConfirmacaoVoltar}
              label="Voltar à Tela Anterior"
            />
            {activeIndex > 0 && (
              <Button
                type="button"
                className="btn btn-secondary"
                onClick={HandleBack}
                label="Voltar"
              />
            )}
            {activeIndex < steps.length - 1 && (
              <Button
                type="button"
                className="btn btn-primary"
                onClick={HandleNext}
                label="Próximo"
              />
            )}
            {activeIndex === steps.length - 1 && (
              <Button
                type="submit"
                className="btn btn-primary"
                onClick={HandleSubmit}
                label="Finalizar"
              />
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormularioFinalizacao;